import { Component } from '@angular/core';

@Component({
  templateUrl: './show-deleted.component.html',
  styleUrls: ['./show-deleted.component.css'],
})
export class ShowDeletedComponent {

}
